import { ref as k, onMounted as V, onUnmounted as j, unref as te, watch as q, computed as T, toValue as ce, getCurrentInstance as ne, openBlock as $, createElementBlock as E, Fragment as oe, renderList as ae, normalizeStyle as F, normalizeClass as Y, renderSlot as B, createCommentVNode as z, createElementVNode as I, createVNode as G, Transition as U, withCtx as X, createTextVNode as Q, toRef as re, toDisplayString as O, createBlock as W, resolveDynamicComponent as se, TransitionGroup as de, Teleport as ee, resolveComponent as fe, nextTick as me, withModifiers as ie, watchEffect as le } from "vue";
import { useRouter as pe } from "vue-router";
function N() {
  const e = k(!1);
  let t;
  V(() => {
    t = window.matchMedia("(prefers-reduced-motion: reduce)"), e.value = t.matches, t.addEventListener("change", n);
  }), j(() => {
    t == null || t.removeEventListener("change", n);
  });
  function n(i) {
    e.value = i.matches;
  }
  return { reducedMotion: e };
}
const ve = {
  smooth: { mass: 1, stiffness: 100, damping: 20 },
  snappy: { mass: 1, stiffness: 300, damping: 22 },
  bouncy: { mass: 1, stiffness: 150, damping: 10 },
  stiff: { mass: 1, stiffness: 500, damping: 30 },
  gentle: { mass: 1, stiffness: 50, damping: 12 },
  quick: { mass: 0.5, stiffness: 400, damping: 20 }
};
function ue(e, t = "smooth") {
  const { reducedMotion: n } = N();
  let i = m(t);
  const r = k(te(e)), l = k(0), u = k(!1);
  let a = te(e), s = null;
  (e == null ? void 0 : e.value) !== void 0 && q(e, (f) => p(f));
  function m(f) {
    return typeof f == "string" ? { ...ve[f] } : { ...f };
  }
  function p(f, h) {
    if (a = f, h && (i = m(h)), n.value) {
      r.value = a, l.value = 0, u.value = !1;
      return;
    }
    u.value || (u.value = !0, s = requestAnimationFrame(c));
  }
  function v(f) {
    cancelAnimationFrame(s), r.value = f, a = f, l.value = 0, u.value = !1;
  }
  function y() {
    cancelAnimationFrame(s), l.value = 0, u.value = !1;
  }
  function c() {
    const f = 0.016666666666666666, { mass: h, stiffness: w, damping: o } = i, b = -w * (r.value - a), x = -o * l.value, g = (b + x) / h;
    l.value += g * f, r.value += l.value * f, Math.abs(l.value) < 0.01 && Math.abs(r.value - a) < 0.01 ? (r.value = a, l.value = 0, u.value = !1) : s = requestAnimationFrame(c);
  }
  return j(() => cancelAnimationFrame(s)), { current: r, velocity: l, isAnimating: u, set: p, snap: v, stop: y };
}
function Mt() {
  const e = k(typeof navigator < "u" && "vibrate" in navigator);
  function t(n) {
    e.value && navigator.vibrate(n);
  }
  return {
    isSupported: e,
    tap: () => t(10),
    confirm: () => t(50),
    success: () => t([30, 50, 60]),
    warning: () => t([50, 30, 50]),
    selection: () => t(5)
  };
}
function $t(e, t) {
  const n = k(!1), i = k(!1), r = k(null);
  async function l(a) {
    r.value = null, i.value = !1, a == null || a(), n.value = !0;
    try {
      await e(), i.value = !0;
    } catch (s) {
      r.value = s, t == null || t();
    } finally {
      n.value = !1;
    }
  }
  function u() {
    n.value = !1, i.value = !1, r.value = null;
  }
  return { execute: l, isPending: n, isConfirmed: i, error: r, reset: u };
}
function _t() {
  const e = k("system"), t = k("light");
  let n;
  const i = T(() => e.value === "system" ? t.value === "dark" : e.value === "dark");
  V(() => {
    const s = localStorage.getItem("color-scheme");
    s && (e.value = s), n = window.matchMedia("(prefers-color-scheme: dark)"), t.value = n.matches ? "dark" : "light", n.addEventListener("change", r), l();
  }), j(() => {
    n == null || n.removeEventListener("change", r);
  }), q(i, l);
  function r(s) {
    t.value = s.matches ? "dark" : "light";
  }
  function l() {
    document.documentElement.classList.toggle("dark", i.value);
  }
  function u(s) {
    e.value = s, localStorage.setItem("color-scheme", s);
  }
  async function a(s) {
    const m = !i.value;
    if (s && document.startViewTransition) {
      const p = s.clientX, v = s.clientY, y = Math.hypot(
        Math.max(p, window.innerWidth - p),
        Math.max(v, window.innerHeight - v)
      );
      await document.startViewTransition(() => {
        u(m ? "dark" : "light");
      }).ready, document.documentElement.animate(
        {
          clipPath: [
            `circle(0px at ${p}px ${v}px)`,
            `circle(${y}px at ${p}px ${v}px)`
          ]
        },
        {
          duration: 500,
          easing: "cubic-bezier(0.4, 0, 0.2, 1)",
          pseudoElement: "::view-transition-new(root)"
        }
      );
    } else
      u(m ? "dark" : "light");
  }
  return { isDark: i, preference: e, systemPreference: t, toggle: a, set: u };
}
const J = {
  "fade-up": {
    from: { opacity: "0", transform: "translateY(30px)" },
    to: { opacity: "1", transform: "translateY(0)" }
  },
  "fade-down": {
    from: { opacity: "0", transform: "translateY(-30px)" },
    to: { opacity: "1", transform: "translateY(0)" }
  },
  "fade-left": {
    from: { opacity: "0", transform: "translateX(30px)" },
    to: { opacity: "1", transform: "translateX(0)" }
  },
  "fade-right": {
    from: { opacity: "0", transform: "translateX(-30px)" },
    to: { opacity: "1", transform: "translateX(0)" }
  },
  "zoom-in": {
    from: { opacity: "0", transform: "scale(0.9)" },
    to: { opacity: "1", transform: "scale(1)" }
  },
  "zoom-out": {
    from: { opacity: "0", transform: "scale(1.1)" },
    to: { opacity: "1", transform: "scale(1)" }
  }
};
function St(e, t = {}) {
  const {
    animation: n = "fade-up",
    threshold: i = 0.15,
    duration: r = 500,
    delay: l = 0,
    once: u = !0
  } = t, { reducedMotion: a } = N(), s = k(!1), m = k(!1);
  let p;
  V(() => {
    const y = e.value;
    if (y) {
      if (a.value) {
        Object.assign(y.style, J[n].to), s.value = !0, m.value = !0;
        return;
      }
      Object.assign(y.style, J[n].from), p = new IntersectionObserver(
        ([c]) => {
          c.isIntersecting ? (s.value = !0, m.value = !0, y.style.transition = `all ${r}ms cubic-bezier(0.05, 0.7, 0.1, 1.0) ${l}ms`, Object.assign(y.style, J[n].to), u && p.disconnect()) : u || (s.value = !1, y.style.transition = "none", Object.assign(y.style, J[n].from));
        },
        { threshold: i }
      ), p.observe(y);
    }
  }), j(() => p == null ? void 0 : p.disconnect());
  function v() {
    const y = e.value;
    !y || a.value || (y.style.transition = "none", Object.assign(y.style, J[n].from), requestAnimationFrame(() => {
      y.style.transition = `all ${r}ms cubic-bezier(0.05, 0.7, 0.1, 1.0) ${l}ms`, Object.assign(y.style, J[n].to);
    }));
  }
  return { isVisible: s, hasAnimated: m, replay: v };
}
function xt(e, t, n = {}) {
  const { timeout: i = 3e3, once: r = !1 } = n, l = k(0), u = k(!1);
  let a = null;
  function s(p) {
    u.value && r || (p.key === e[l.value] ? (l.value++, clearTimeout(a), a = setTimeout(m, i), l.value === e.length && (u.value = !0, clearTimeout(a), t(), r || (l.value = 0))) : l.value = 0);
  }
  function m() {
    l.value = 0, u.value = !1;
  }
  return V(() => window.addEventListener("keydown", s)), j(() => {
    window.removeEventListener("keydown", s), clearTimeout(a);
  }), { progress: l, isComplete: u, reset: m };
}
function Et(e, t) {
  const n = (t == null ? void 0 : t.src) ?? t ?? null, i = k("#888888"), r = k("#6366f1"), l = k("#9ca3af"), u = k([]), a = k(!1), s = k(!1);
  function m() {
    const c = e.value;
    if (c) {
      if (!c.complete || !c.naturalWidth) {
        c.addEventListener("load", () => p(c), { once: !0 });
        return;
      }
      s.value = !0, p(c);
    }
  }
  function p(c) {
    s.value = !0;
    const f = new Image();
    f.crossOrigin = "anonymous", f.onload = () => {
      const h = document.createElement("canvas"), w = h.getContext("2d", { willReadFrequently: !0 }), o = 64;
      h.width = o, h.height = o;
      try {
        w.drawImage(f, 0, 0, o, o);
        const b = w.getImageData(0, 0, o, o).data, x = /* @__PURE__ */ new Map(), g = 24;
        for (let M = 0; M < b.length; M += 16) {
          const S = Math.floor(b[M] / g) * g, P = Math.floor(b[M + 1] / g) * g, _ = Math.floor(b[M + 2] / g) * g, C = `${S},${P},${_}`;
          x.set(C, (x.get(C) || 0) + 1);
        }
        const d = [...x.entries()].filter(([M]) => {
          const [S, P, _] = M.split(",").map(Number), C = (0.299 * S + 0.587 * P + 0.114 * _) / 255;
          return C > 0.05 && C < 0.9;
        }), A = (d.length >= 3 ? d : [...x.entries()]).sort((M, S) => S[1] - M[1]).slice(0, 8).map(([M]) => {
          const [S, P, _] = M.split(",").map(Number);
          return { r: S, g: P, b: _, hex: v(S, P, _) };
        });
        if (A.length) {
          u.value = A.map((_) => _.hex), i.value = A[0].hex;
          const M = (0.299 * A[0].r + 0.587 * A[0].g + 0.114 * A[0].b) / 255;
          a.value = M < 0.5;
          let S = 0, P = 1 / 0;
          for (const _ of A) {
            const C = y(_.r, _.g, _.b);
            C > S && (S = C, r.value = _.hex), C < P && (P = C, l.value = _.hex);
          }
        }
      } catch {
      }
      s.value = !1;
    }, f.onerror = () => {
      s.value = !1;
    }, f.src = c.src;
  }
  function v(c, f, h) {
    return "#" + [c, f, h].map((w) => Math.min(255, w).toString(16).padStart(2, "0")).join("");
  }
  function y(c, f, h) {
    const w = Math.max(c, f, h), o = Math.min(c, f, h);
    return w === 0 ? 0 : (w - o) / w;
  }
  return V(() => {
    const c = e.value;
    c && (c.complete && c.naturalWidth ? m() : c.addEventListener("load", m, { once: !0 }));
  }), n && q(
    () => ce(n),
    () => {
      const c = e.value;
      c && c.addEventListener("load", m, { once: !0 });
    }
  ), { dominant: i, vibrant: r, muted: l, palette: u, isDark: a, isLoading: s, extract: m };
}
function Tt(e, t = {}) {
  const {
    trigger: n = "hover",
    elementRef: i = null,
    hoverDelay: r = 100,
    idleTimeout: l = 2e3,
    fetchFn: u = null
  } = t, a = k(null), s = k(!1), m = k(!1);
  let p = null, v = null, y = null;
  async function c() {
    if (!(s.value || m.value)) {
      m.value = !0;
      try {
        u ? a.value = await u() : await fetch(typeof e == "string" ? e : e.value, { priority: "low" }), s.value = !0;
      } catch {
      } finally {
        m.value = !1;
      }
    }
  }
  function f() {
    const w = i == null ? void 0 : i.value;
    if (n === "hover" && w) {
      const o = () => {
        p = setTimeout(c, r);
      }, b = () => clearTimeout(p);
      w.addEventListener("pointerenter", o), w.addEventListener("pointerleave", b), y = () => {
        w.removeEventListener("pointerenter", o), w.removeEventListener("pointerleave", b);
      };
    } else n === "visible" && w ? (v = new IntersectionObserver(
      ([o]) => {
        o.isIntersecting && (c(), v.disconnect());
      },
      { threshold: 0.1 }
    ), v.observe(w)) : n === "idle" && (typeof requestIdleCallback < "u" ? requestIdleCallback(() => setTimeout(c, l)) : setTimeout(c, l));
  }
  return i != null && i.value ? f() : ne() && V(f), ne() && j(() => {
    clearTimeout(p), v == null || v.disconnect(), y == null || y();
  }), { data: a, isPrefetched: s, isPrefetching: m, prefetch: c };
}
function Lt() {
  const { reducedMotion: e } = N(), t = k(typeof document < "u" && "startViewTransition" in document), n = k(!1);
  async function i(l) {
    if (!t.value || e.value) {
      await l();
      return;
    }
    n.value = !0;
    const u = document.startViewTransition(async () => {
      await l();
    });
    try {
      await u.finished;
    } finally {
      n.value = !1;
    }
  }
  function r(l, u) {
    l && (l.style.viewTransitionName = u);
  }
  return { isSupported: t, isTransitioning: n, navigate: i, setTransitionName: r };
}
function Ct(e, t, n = {}) {
  const {
    threshold: i = 80,
    maxPull: r = 150,
    resistance: l = 0.4
  } = n, { reducedMotion: u } = N(), a = k(0), s = k(0), m = k(!1), p = k(!1);
  let v = 0;
  function y(h) {
    const w = e.value;
    !w || w.scrollTop > 0 || m.value || (v = h.touches[0].clientY, p.value = !0);
  }
  function c(h) {
    if (!p.value) return;
    const w = h.touches[0].clientY - v;
    if (w < 0) {
      a.value = 0;
      return;
    }
    const o = Math.min(w * l, r);
    a.value = o, s.value = Math.min(o / i, 1);
  }
  async function f() {
    if (p.value) {
      if (p.value = !1, a.value >= i && !m.value) {
        m.value = !0;
        try {
          await t();
        } finally {
          m.value = !1;
        }
      }
      if (u.value)
        a.value = 0, s.value = 0;
      else {
        let b = function(x) {
          const g = Math.min((x - o) / w, 1), d = 1 - Math.pow(1 - g, 3);
          a.value = h * (1 - d), s.value = Math.min(a.value / i, 1), g < 1 && requestAnimationFrame(b);
        };
        const h = a.value, w = 300, o = performance.now();
        requestAnimationFrame(b);
      }
    }
  }
  return V(() => {
    const h = e.value;
    h && (h.addEventListener("touchstart", y, { passive: !0 }), h.addEventListener("touchmove", c, { passive: !0 }), h.addEventListener("touchend", f));
  }), j(() => {
    const h = e.value;
    h && (h.removeEventListener("touchstart", y), h.removeEventListener("touchmove", c), h.removeEventListener("touchend", f));
  }), { pullDistance: a, pullProgress: s, isRefreshing: m, isPulling: p };
}
function Pt(e = {}) {
  const {
    edgeWidth: t = 24,
    threshold: n = 0.4,
    velocityThreshold: i = 0.5,
    onBack: r = null
  } = e, { reducedMotion: l } = N(), u = k(0), a = k(!1), s = k(!1);
  let m = 0, p = 0, v = 0, y = !1;
  function c(b) {
    const x = b.touches[0];
    x.clientX > t || (m = x.clientX, p = Date.now(), v = m, y = !0, a.value = !0);
  }
  function f(b) {
    if (!y) return;
    v = b.touches[0].clientX;
    const x = Math.max(0, v - m);
    u.value = Math.min(x / window.innerWidth, 1), s.value = u.value > 0.01;
  }
  function h() {
    if (!y) return;
    y = !1;
    const b = v - m, x = Date.now() - p, g = b / x;
    (u.value >= n || g >= i) && r ? l.value ? (r(), o()) : w(1, () => {
      r(), o();
    }) : l.value ? o() : w(0, o);
  }
  function w(b, x) {
    const g = u.value, d = 250, L = performance.now();
    function A(M) {
      const S = Math.min((M - L) / d, 1), P = 1 - Math.pow(1 - S, 3);
      u.value = g + (b - g) * P, S < 1 ? requestAnimationFrame(A) : (u.value = b, x == null || x());
    }
    requestAnimationFrame(A);
  }
  function o() {
    u.value = 0, a.value = !1, s.value = !1;
  }
  return V(() => {
    document.addEventListener("touchstart", c, { passive: !0 }), document.addEventListener("touchmove", f, { passive: !0 }), document.addEventListener("touchend", h);
  }), j(() => {
    document.removeEventListener("touchstart", c), document.removeEventListener("touchmove", f), document.removeEventListener("touchend", h);
  }), { progress: u, isSwiping: a, isActive: s };
}
const R = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, ye = {
  key: 0,
  class: "skeleton-group"
}, he = {
  __name: "Skeleton",
  props: {
    variant: { type: String, default: "text" },
    width: { type: [String, Number], default: "100%" },
    height: { type: [String, Number], default: "1em" },
    lines: { type: Number, default: 1 },
    lineSpacing: { type: String, default: "0.5em" },
    lastLineWidth: { type: String, default: "60%" },
    animation: { type: String, default: "shimmer" },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { reducedMotion: n } = N(), i = T(() => t.motion && !n.value && t.animation !== "none"), r = T(() => i.value ? `skeleton--${t.animation}` : "");
    function l(u) {
      return typeof u == "number" ? `${u}px` : u;
    }
    return (u, a) => e.variant === "text" && e.lines > 1 ? ($(), E("div", ye, [
      ($(!0), E(oe, null, ae(e.lines, (s) => ($(), E("div", {
        key: s,
        class: Y(["skeleton skeleton--text", [r.value, { "skeleton--no-motion": !i.value }]]),
        style: F({
          width: s === e.lines ? e.lastLineWidth : e.width,
          height: e.height,
          marginBottom: s < e.lines ? e.lineSpacing : "0"
        })
      }, null, 6))), 128))
    ])) : ($(), E("div", {
      key: 1,
      class: Y(["skeleton", [`skeleton--${e.variant}`, r.value, { "skeleton--no-motion": !i.value }]]),
      style: F({ width: l(e.width), height: l(e.height) })
    }, [
      B(u.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}, Bt = /* @__PURE__ */ R(he, [["__scopeId", "data-v-05724a3e"]]), ge = ["src", "alt"], be = {
  key: 1,
  class: "progressive-image__skeleton"
}, we = ["src", "alt"], ke = {
  __name: "ProgressiveImage",
  props: {
    src: { type: String, required: !0 },
    placeholder: { type: String, default: void 0 },
    alt: { type: String, default: "" },
    width: { type: [String, Number], default: void 0 },
    height: { type: [String, Number], default: void 0 },
    objectFit: { type: String, default: "cover" },
    blurRadius: { type: Number, default: 20 },
    lazy: { type: Boolean, default: !0 },
    lazyThreshold: { type: Number, default: 0.1 },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["load", "error"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = k(!1), l = k(n.lazy ? "" : n.src), u = k(null);
    let a;
    const s = T(() => ({
      width: typeof n.width == "number" ? `${n.width}px` : n.width,
      height: typeof n.height == "number" ? `${n.height}px` : n.height
    }));
    function m(v) {
      r.value = !0, i("load", v);
    }
    function p(v) {
      i("error", v);
    }
    return V(() => {
      n.lazy && (a = new IntersectionObserver(
        ([v]) => {
          v.isIntersecting && (l.value = n.src, a.disconnect());
        },
        { threshold: n.lazyThreshold }
      ), u.value && a.observe(u.value));
    }), j(() => a == null ? void 0 : a.disconnect()), (v, y) => ($(), E("div", {
      class: "progressive-image",
      style: F(s.value)
    }, [
      e.placeholder ? ($(), E("img", {
        key: 0,
        src: e.placeholder,
        alt: e.alt,
        class: Y(["progressive-image__placeholder", { "progressive-image__placeholder--loaded": r.value }]),
        style: F({ filter: `blur(${e.blurRadius}px)` }),
        "aria-hidden": "true"
      }, null, 14, ge)) : r.value ? z("", !0) : ($(), E("div", be)),
      I("img", {
        ref_key: "fullImg",
        ref: u,
        src: l.value,
        alt: e.alt,
        class: Y(["progressive-image__full", { "progressive-image__full--loaded": r.value }]),
        style: F({ objectFit: e.objectFit }),
        onLoad: m,
        onError: p
      }, null, 46, we)
    ], 4));
  }
}, At = /* @__PURE__ */ R(ke, [["__scopeId", "data-v-7313ec4f"]]), Me = ["disabled"], $e = {
  key: "idle",
  class: "morph-button__label"
}, _e = {
  key: "loading",
  class: "morph-button__spinner"
}, Se = {
  key: "success",
  class: "morph-button__check"
}, xe = {
  key: "error",
  class: "morph-button__error-label"
}, Ee = {
  __name: "MorphButton",
  props: {
    state: { type: String, default: "idle" },
    color: { type: String, default: "#6366f1" },
    successColor: { type: String, default: "#10b981" },
    errorColor: { type: String, default: "#ef4444" },
    size: { type: String, default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    resetDelay: { type: Number, default: 2e3 },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["click", "reset"],
  setup(e, { emit: t }) {
    const n = e, i = t, { reducedMotion: r } = N(), l = T(() => n.motion && !r.value), u = T(() => ({ "--morph-color": n.state === "success" ? n.successColor : n.state === "error" ? n.errorColor : n.color }));
    return q(() => n.state, (a) => {
      (a === "success" || a === "error") && n.resetDelay > 0 && setTimeout(() => i("reset"), n.resetDelay);
    }), (a, s) => ($(), E("button", {
      class: Y(["morph-button", [
        `morph-button--${e.state}`,
        `morph-button--${e.size}`,
        { "morph-button--full": e.fullWidth && e.state === "idle" }
      ]]),
      style: F(u.value),
      disabled: e.state !== "idle",
      onClick: s[0] || (s[0] = (m) => a.$emit("click", m))
    }, [
      G(U, {
        name: l.value ? "morph-content" : "",
        mode: "out-in"
      }, {
        default: X(() => [
          e.state === "idle" ? ($(), E("span", $e, [
            B(a.$slots, "default", {}, () => [
              s[1] || (s[1] = Q("Submit", -1))
            ], !0)
          ])) : e.state === "loading" ? ($(), E("span", _e, [
            B(a.$slots, "loading", {}, () => [
              s[2] || (s[2] = I("svg", {
                viewBox: "0 0 24 24",
                class: "morph-button__spin-icon"
              }, [
                I("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-dasharray": "50 20"
                })
              ], -1))
            ], !0)
          ])) : e.state === "success" ? ($(), E("span", Se, [
            B(a.$slots, "success", {}, () => [
              s[3] || (s[3] = I("svg", {
                viewBox: "0 0 24 24",
                class: "morph-button__check-icon"
              }, [
                I("path", {
                  d: "M5 13l4 4L19 7",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "check-path"
                })
              ], -1))
            ], !0)
          ])) : e.state === "error" ? ($(), E("span", xe, [
            B(a.$slots, "error", {}, () => [
              s[4] || (s[4] = Q("Retry", -1))
            ], !0)
          ])) : z("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 14, Me));
  }
}, It = /* @__PURE__ */ R(Ee, [["__scopeId", "data-v-d5f33913"]]), Te = {
  __name: "Confetti",
  props: {
    trigger: { type: Boolean, default: !1 },
    particleCount: { type: Number, default: 80 },
    spread: { type: Number, default: 60 },
    origin: { type: Object, default: () => ({ x: 0.5, y: 0.5 }) },
    colors: { type: Array, default: void 0 },
    gravity: { type: Number, default: 0.5 },
    duration: { type: Number, default: 3e3 },
    shapes: { type: Array, default: () => ["square", "circle", "strip"] },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["start", "complete"],
  setup(e, { expose: t, emit: n }) {
    const i = ["#FF6B6B", "#4ECDC4", "#FFE66D", "#A78BFA", "#F472B6", "#34D399", "#60A5FA", "#FBBF24"], r = e, l = n, u = k(null), { reducedMotion: a } = N();
    let s = null;
    q(() => r.trigger, (p) => {
      p && m();
    });
    function m(p = {}) {
      if (!r.motion || a.value) return;
      const v = u.value;
      if (!v) return;
      v.width = window.innerWidth, v.height = window.innerHeight;
      const y = v.getContext("2d"), c = { ...r, colors: r.colors || i, ...p }, f = [];
      for (let w = 0; w < c.particleCount; w++) {
        const o = (Math.random() - 0.5) * c.spread * Math.PI / 180 - Math.PI / 2, b = Math.random() * 15 + 10;
        f.push({
          x: c.origin.x * v.width,
          y: c.origin.y * v.height,
          vx: Math.cos(o) * b * (Math.random() * 0.6 + 0.7),
          vy: Math.sin(o) * b * (Math.random() * 0.6 + 0.7),
          gravity: c.gravity,
          drag: 0.97,
          color: c.colors[Math.floor(Math.random() * c.colors.length)],
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 15,
          size: Math.random() * 8 + 4,
          shape: c.shapes[Math.floor(Math.random() * c.shapes.length)],
          life: 1,
          decay: 5e-3 + Math.random() * 0.01
        });
      }
      l("start");
      function h() {
        y.clearRect(0, 0, v.width, v.height);
        let w = 0;
        for (const o of f)
          o.vx *= o.drag, o.vy *= o.drag, o.vy += o.gravity, o.x += o.vx, o.y += o.vy, o.rotation += o.rotationSpeed, o.life -= o.decay, !(o.life <= 0) && (w++, y.save(), y.translate(o.x, o.y), y.rotate(o.rotation * Math.PI / 180), y.globalAlpha = o.life, y.fillStyle = o.color, o.shape === "circle" ? (y.beginPath(), y.arc(0, 0, o.size / 2, 0, Math.PI * 2), y.fill()) : o.shape === "strip" ? y.fillRect(-o.size / 2, -1, o.size, 3) : y.fillRect(-o.size / 2, -o.size / 2, o.size, o.size), y.restore());
        w > 0 ? s = requestAnimationFrame(h) : (y.clearRect(0, 0, v.width, v.height), l("complete"));
      }
      cancelAnimationFrame(s), h();
    }
    return j(() => cancelAnimationFrame(s)), t({ fire: m }), (p, v) => ($(), E("canvas", {
      ref_key: "canvasRef",
      ref: u,
      class: "confetti-canvas",
      style: { pointerEvents: "none", position: "fixed", inset: 0, zIndex: 9999 }
    }, null, 512));
  }
}, Le = /* @__PURE__ */ R(Te, [["__scopeId", "data-v-7771d3db"]]), Ce = { class: "animated-counter" }, zt = {
  __name: "AnimatedCounter",
  props: {
    value: { type: Number, required: !0 },
    format: { type: Function, default: null },
    spring: { type: [String, Object], default: "snappy" },
    precision: { type: Number, default: 0 },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = re(t, "value"), { current: i } = ue(n, t.motion ? t.spring : "stiff"), r = T(() => Number(i.value.toFixed(t.precision))), l = T(() => t.format ? t.format(r.value) : new Intl.NumberFormat(void 0, {
      minimumFractionDigits: t.precision,
      maximumFractionDigits: t.precision
    }).format(r.value));
    return (u, a) => ($(), E("span", Ce, [
      B(u.$slots, "default", {
        value: r.value,
        formatted: l.value
      }, () => [
        Q(O(l.value), 1)
      ])
    ]));
  }
}, Pe = {
  __name: "GlassCard",
  props: {
    blur: { type: Number, default: 16 },
    opacity: { type: Number, default: 0.12 },
    tint: { type: String, default: "#ffffff" },
    border: { type: Boolean, default: !0 },
    elevated: { type: Boolean, default: !1 },
    rounded: { type: [String, Number], default: "16px" },
    tag: { type: String, default: "div" }
  },
  setup(e) {
    const t = e;
    function n(r, l) {
      const u = parseInt(r.slice(1, 3), 16), a = parseInt(r.slice(3, 5), 16), s = parseInt(r.slice(5, 7), 16);
      return `rgba(${u}, ${a}, ${s}, ${l})`;
    }
    const i = T(() => ({
      background: n(t.tint, t.opacity),
      backdropFilter: `blur(${t.elevated ? t.blur * 1.5 : t.blur}px)`,
      WebkitBackdropFilter: `blur(${t.elevated ? t.blur * 1.5 : t.blur}px)`,
      borderRadius: typeof t.rounded == "number" ? `${t.rounded}px` : t.rounded,
      border: t.border ? "1px solid var(--glass-border-color, rgba(255, 255, 255, 0.18))" : "none"
    }));
    return (r, l) => ($(), W(se(e.tag), {
      class: Y(["glass-card", { "glass-card--elevated": e.elevated }]),
      style: F(i.value)
    }, {
      default: X(() => [
        B(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
}, Ft = /* @__PURE__ */ R(Pe, [["__scopeId", "data-v-bfbcc66d"]]), Nt = {
  __name: "StaggeredList",
  props: {
    tag: { type: String, default: "div" },
    delay: { type: Number, default: 50 },
    maxDelay: { type: Number, default: 300 },
    duration: { type: Number, default: 400 },
    animation: { type: String, default: "fade-up" },
    distance: { type: Number, default: 20 },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = {
      "fade-up": "translateY(20px)",
      "fade-down": "translateY(-20px)",
      "fade-left": "translateX(20px)",
      "fade-right": "translateX(-20px)",
      "zoom-in": "scale(0.9)"
    }, n = e, { reducedMotion: i } = N();
    function r() {
      return n.motion && !i.value;
    }
    function l(s) {
      r() && (s.style.opacity = "0", s.style.transform = t[n.animation] || t["fade-up"]);
    }
    function u(s, m) {
      if (!r()) {
        m();
        return;
      }
      const p = Array.from(s.parentNode.children).indexOf(s), v = Math.min(p * n.delay, n.maxDelay);
      s.style.transition = `
    opacity ${n.duration}ms cubic-bezier(0.05, 0.7, 0.1, 1.0) ${v}ms,
    transform ${n.duration}ms cubic-bezier(0.05, 0.7, 0.1, 1.0) ${v}ms
  `, requestAnimationFrame(() => {
        s.style.opacity = "1", s.style.transform = "translateY(0) translateX(0) scale(1)";
      }), setTimeout(m, n.duration + v);
    }
    function a(s, m) {
      if (!r()) {
        m();
        return;
      }
      s.style.transition = "opacity 200ms cubic-bezier(0.3, 0, 0.8, 0.15)", s.style.opacity = "0", setTimeout(m, 200);
    }
    return (s, m) => ($(), W(de, {
      tag: e.tag,
      css: !1,
      onBeforeEnter: l,
      onEnter: u,
      onLeave: a
    }, {
      default: X(() => [
        B(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["tag"]));
  }
}, Be = { class: "empty-state__icon" }, Ae = ["src"], Ie = {
  key: 1,
  class: "empty-state__icon-text"
}, ze = {
  key: 2,
  viewBox: "0 0 64 64",
  class: "empty-state__default-icon"
}, Fe = { class: "empty-state__title" }, Ne = {
  key: 0,
  class: "empty-state__description"
}, De = {
  key: 1,
  class: "empty-state__action"
}, Re = {
  key: 2,
  class: "empty-state__footer"
}, Oe = {
  __name: "EmptyState",
  props: {
    icon: { type: String, default: void 0 },
    illustration: { type: String, default: void 0 },
    title: { type: String, required: !0 },
    description: { type: String, default: void 0 },
    actionLabel: { type: String, default: void 0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (t, n) => ($(), E("div", {
      class: Y(["empty-state", { "empty-state--compact": e.compact }])
    }, [
      I("div", Be, [
        B(t.$slots, "icon", {}, () => [
          e.illustration ? ($(), E("img", {
            key: 0,
            src: e.illustration,
            alt: "",
            class: "empty-state__illustration"
          }, null, 8, Ae)) : e.icon ? ($(), E("span", Ie, O(e.icon), 1)) : ($(), E("svg", ze, [...n[1] || (n[1] = [
            I("circle", {
              cx: "32",
              cy: "32",
              r: "28",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              opacity: "0.3"
            }, null, -1),
            I("path", {
              d: "M24 28h16M24 36h10",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              opacity: "0.4"
            }, null, -1)
          ])]))
        ], !0)
      ]),
      I("h3", Fe, [
        B(t.$slots, "title", {}, () => [
          Q(O(e.title), 1)
        ], !0)
      ]),
      e.description || t.$slots.description ? ($(), E("p", Ne, [
        B(t.$slots, "description", {}, () => [
          Q(O(e.description), 1)
        ], !0)
      ])) : z("", !0),
      e.actionLabel || t.$slots.action ? ($(), E("div", De, [
        B(t.$slots, "action", {}, () => [
          I("button", {
            class: "empty-state__button",
            onClick: n[0] || (n[0] = (i) => t.$emit("action"))
          }, O(e.actionLabel), 1)
        ], !0)
      ])) : z("", !0),
      t.$slots.footer ? ($(), E("div", Re, [
        B(t.$slots, "footer", {}, void 0, !0)
      ])) : z("", !0)
    ], 2));
  }
}, Dt = /* @__PURE__ */ R(Oe, [["__scopeId", "data-v-2932fa34"]]), Ye = { class: "error-state__icon" }, Xe = { class: "error-state__title" }, je = { class: "error-state__description" }, qe = {
  key: 0,
  class: "error-state__actions"
}, We = {
  __name: "ErrorState",
  props: {
    icon: { type: [String, Object], default: void 0 },
    title: { type: String, default: "Something went wrong" },
    description: { type: String, default: "Please try again." },
    retryLabel: { type: String, default: "Try Again" },
    error: { type: [Error, String], default: void 0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["retry"],
  setup(e) {
    return (t, n) => ($(), E("div", {
      class: Y(["error-state", { "error-state--compact": e.compact }])
    }, [
      I("div", Ye, [
        B(t.$slots, "icon", {}, () => [
          n[1] || (n[1] = I("svg", {
            viewBox: "0 0 64 64",
            class: "error-state__default-icon"
          }, [
            I("circle", {
              cx: "32",
              cy: "32",
              r: "28",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2"
            }),
            I("path", {
              d: "M32 20v16M32 42v2",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round"
            })
          ], -1))
        ], !0)
      ]),
      I("h3", Xe, O(e.title), 1),
      I("p", je, O(e.description), 1),
      e.retryLabel || t.$slots.actions ? ($(), E("div", qe, [
        B(t.$slots, "actions", {}, () => [
          e.retryLabel ? ($(), E("button", {
            key: 0,
            class: "error-state__retry",
            onClick: n[0] || (n[0] = (i) => t.$emit("retry"))
          }, O(e.retryLabel), 1)) : z("", !0)
        ], !0)
      ])) : z("", !0)
    ], 2));
  }
}, Rt = /* @__PURE__ */ R(We, [["__scopeId", "data-v-4d46dda2"]]), Ve = {
  key: 0,
  class: "achievement-toast__icon-text"
}, He = { class: "achievement-toast__content" }, Ue = { class: "achievement-toast__title" }, Ge = {
  key: 0,
  class: "achievement-toast__description"
}, Ke = {
  __name: "AchievementToast",
  props: {
    visible: { type: Boolean, default: !1 },
    title: { type: String, required: !0 },
    description: { type: String, default: void 0 },
    icon: { type: String, default: void 0 },
    iconColor: { type: String, default: "#fbbf24" },
    celebration: { type: String, default: "confetti" },
    duration: { type: Number, default: 4e3 },
    position: { type: String, default: "top" },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const n = e, i = t, { reducedMotion: r } = N(), l = T(() => n.motion && !r.value), u = k(null);
    let a;
    q(() => n.visible, (m) => {
      clearTimeout(a), m && n.duration > 0 && (a = setTimeout(s, n.duration));
    });
    function s() {
      i("dismiss");
    }
    return (m, p) => ($(), W(ee, { to: "body" }, [
      G(U, {
        name: l.value ? "toast" : ""
      }, {
        default: X(() => [
          e.visible ? ($(), E("div", {
            key: 0,
            class: Y(["achievement-toast", [`achievement-toast--${e.position}`]]),
            onClick: s
          }, [
            I("div", {
              class: "achievement-toast__icon",
              style: F({ color: e.iconColor })
            }, [
              B(m.$slots, "icon", {}, () => [
                e.icon ? ($(), E("span", Ve, O(e.icon), 1)) : z("", !0)
              ], !0)
            ], 4),
            I("div", He, [
              B(m.$slots, "default", {}, () => [
                I("div", Ue, O(e.title), 1),
                e.description ? ($(), E("div", Ge, O(e.description), 1)) : z("", !0)
              ], !0)
            ])
          ], 2)) : z("", !0)
        ]),
        _: 3
      }, 8, ["name"]),
      e.celebration === "confetti" ? ($(), W(Le, {
        key: 0,
        ref_key: "confettiRef",
        ref: u,
        trigger: e.visible,
        origin: { x: 0.5, y: 0.15 },
        "particle-count": 60,
        motion: l.value
      }, null, 8, ["trigger", "motion"])) : z("", !0)
    ]));
  }
}, Ot = /* @__PURE__ */ R(Ke, [["__scopeId", "data-v-415bb238"]]), Je = {
  __name: "Fireworks",
  props: {
    trigger: { type: Boolean, default: !1 },
    count: { type: Number, default: 5 },
    sparks: { type: Number, default: 50 },
    colors: { type: Array, default: void 0 },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["start", "complete"],
  setup(e, { expose: t, emit: n }) {
    const i = [
      "#FF6B6B",
      "#4ECDC4",
      "#FFE66D",
      "#A78BFA",
      "#F472B6",
      "#60A5FA",
      "#FBBF24",
      "#34D399"
    ], r = e, l = n, u = k(null), { reducedMotion: a } = N();
    let s = null, m = !1;
    const p = [], v = [];
    let y = 0;
    q(() => r.trigger, (o) => {
      o && c();
    });
    function c(o = {}) {
      if (!r.motion || a.value) return;
      const b = u.value;
      if (!b) return;
      m || (b.width = window.innerWidth, b.height = window.innerHeight);
      const x = { ...r, colors: r.colors || i, ...o };
      y += x.count;
      for (let g = 0; g < x.count; g++)
        setTimeout(() => {
          p.push(h(b, x));
        }, g * 350 + Math.random() * 250);
      if (!m) {
        m = !0, l("start");
        const g = b.getContext("2d");
        f(g, b);
      }
    }
    function f(o, b) {
      o.fillStyle = "rgba(0, 0, 0, 0.12)", o.fillRect(0, 0, b.width, b.height);
      for (let g = p.length - 1; g >= 0; g--) {
        const d = p[g];
        d.vy += d.gravity, d.x += d.vx, d.y += d.vy, Math.random() > 0.3 && v.push({
          x: d.x + (Math.random() - 0.5) * 3,
          y: d.y,
          vx: (Math.random() - 0.5) * 0.8,
          vy: Math.random() * 1.5 + 0.5,
          gravity: 0.02,
          friction: 0.98,
          color: `hsl(40, 100%, ${60 + Math.random() * 30}%)`,
          size: 1.5 + Math.random(),
          life: 1,
          decay: 0.04 + Math.random() * 0.03,
          type: "trail"
        }), o.beginPath(), o.arc(d.x, d.y, 2.5, 0, Math.PI * 2), o.fillStyle = "#fff", o.fill();
        const L = o.createRadialGradient(d.x, d.y, 0, d.x, d.y, 8);
        L.addColorStop(0, "rgba(255, 200, 100, 0.6)"), L.addColorStop(1, "rgba(255, 200, 100, 0)"), o.beginPath(), o.arc(d.x, d.y, 8, 0, Math.PI * 2), o.fillStyle = L, o.fill(), d.vy >= -1.5 && (w(d, config, v), p.splice(g, 1), y--);
      }
      let x = 0;
      for (let g = v.length - 1; g >= 0; g--) {
        const d = v[g];
        if (d.vy += d.gravity, d.vx *= d.friction, d.vy *= d.friction, d.x += d.vx, d.y += d.vy, d.life -= d.decay, d.size *= 0.995, d.life <= 0 || d.size < 0.3) {
          v.splice(g, 1);
          continue;
        }
        if (x++, o.save(), o.globalAlpha = Math.min(d.life, 1), d.type === "spark") {
          const L = Math.sqrt(d.vx * d.vx + d.vy * d.vy) * 3, A = Math.atan2(d.vy, d.vx), M = d.x - Math.cos(A) * L, S = d.y - Math.sin(A) * L, P = o.createLinearGradient(M, S, d.x, d.y);
          P.addColorStop(0, "transparent"), P.addColorStop(1, d.color), o.strokeStyle = P, o.lineWidth = d.size, o.lineCap = "round", o.beginPath(), o.moveTo(M, S), o.lineTo(d.x, d.y), o.stroke(), o.beginPath(), o.arc(d.x, d.y, d.size * 0.8, 0, Math.PI * 2), o.fillStyle = d.color, o.fill();
        } else d.type === "sparkle" ? (o.beginPath(), o.arc(d.x, d.y, d.size, 0, Math.PI * 2), o.fillStyle = d.color, o.globalAlpha *= Math.sin(d.life * 20) * 0.5 + 0.5, o.fill()) : (o.beginPath(), o.arc(d.x, d.y, d.size, 0, Math.PI * 2), o.fillStyle = d.color, o.fill());
        o.restore();
      }
      x > 0 || p.length > 0 || y > 0 ? s = requestAnimationFrame(() => f(o, b)) : (o.clearRect(0, 0, b.width, b.height), m = !1, l("complete"));
    }
    function h(o, b) {
      const x = o.width * (0.15 + Math.random() * 0.7), g = o.height * (0.2 + Math.random() * 0.3), d = o.height - g, L = 0.12, A = -Math.sqrt(2 * L * d);
      return {
        x,
        y: o.height + 10,
        vx: (Math.random() - 0.5) * 2,
        vy: A,
        gravity: L,
        color: b.colors[Math.floor(Math.random() * b.colors.length)]
      };
    }
    function w(o, b, x, g) {
      const d = b.sparks, L = o.color, A = b.colors[Math.floor(Math.random() * b.colors.length)];
      for (let M = 0; M < d; M++) {
        const S = Math.PI * 2 * M / d + (Math.random() - 0.5) * 0.3, P = 2 + Math.random() * 4.5, _ = Math.random() > 0.6;
        x.push({
          x: o.x,
          y: o.y,
          vx: Math.cos(S) * P,
          vy: Math.sin(S) * P,
          gravity: 0.04 + Math.random() * 0.02,
          friction: 0.965 + Math.random() * 0.015,
          color: _ ? A : L,
          size: 1.5 + Math.random() * 1.5,
          life: 0.8 + Math.random() * 0.4,
          decay: 6e-3 + Math.random() * 8e-3,
          type: "spark"
        });
      }
      for (let M = 0; M < d / 3; M++) {
        const S = Math.random() * Math.PI * 2, P = 1 + Math.random() * 3;
        x.push({
          x: o.x,
          y: o.y,
          vx: Math.cos(S) * P,
          vy: Math.sin(S) * P,
          gravity: 0.03,
          friction: 0.97,
          color: "#fff",
          size: 1 + Math.random(),
          life: 0.6 + Math.random() * 0.4,
          decay: 0.01 + Math.random() * 0.015,
          type: "sparkle"
        });
      }
      for (let M = 0; M < 5; M++)
        x.push({
          x: o.x + (Math.random() - 0.5) * 4,
          y: o.y + (Math.random() - 0.5) * 4,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          gravity: 0.01,
          friction: 0.95,
          color: "#fff",
          size: 4 + Math.random() * 3,
          life: 1,
          decay: 0.06 + Math.random() * 0.04,
          type: "flash"
        });
    }
    return j(() => cancelAnimationFrame(s)), t({ fire: c }), (o, b) => ($(), E("canvas", {
      ref_key: "canvasRef",
      ref: u,
      class: "fireworks-canvas",
      style: { pointerEvents: "none", position: "fixed", inset: 0, zIndex: 9999 }
    }, null, 512));
  }
}, Yt = /* @__PURE__ */ R(Je, [["__scopeId", "data-v-3f4b67d5"]]), Xt = {
  __name: "PageTransition",
  props: {
    /** Transition type: 'slide' | 'fade' | 'scale' | 'wipe-left' | 'wipe-right' | 'wipe-up' | 'wipe-down' | 'wipe-circle' */
    type: { type: String, default: "slide" },
    /** Duration in ms */
    duration: { type: Number, default: 350 },
    /** Transition mode — default out-in for non-slide */
    mode: { type: String, default: void 0 },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { reducedMotion: n } = N(), i = T(() => t.motion && !n.value), r = pe(), l = k("forward");
    q(
      () => r.currentRoute.value,
      (p, v) => {
        var c, f, h, w, o, b, x, g;
        if (!v) return;
        const y = (c = p.meta) == null ? void 0 : c._navType;
        if (y) {
          l.value = y;
          return;
        }
        l.value = ((h = (f = window.navigation) == null ? void 0 : f.currentEntry) == null ? void 0 : h.index) < (((g = (b = (o = (w = window.navigation) == null ? void 0 : w.entries) == null ? void 0 : o.call(w)) == null ? void 0 : b.indexOf) == null ? void 0 : g.call(b, (x = window.navigation) == null ? void 0 : x.currentEntry)) ?? 0) ? "back" : "forward";
      }
    ), typeof window < "u" && window.addEventListener("popstate", () => {
      l.value = "back";
    });
    const u = T(() => {
      const p = t.type;
      return p === "slide" ? l.value === "back" ? "page-slide-back" : "page-slide-forward" : p === "fade" ? "page-fade" : p === "scale" ? "page-scale" : p.startsWith("wipe") ? `page-${p}` : "page-slide-forward";
    }), a = T(() => {
      if (t.mode) return t.mode;
      if (t.type !== "slide")
        return "out-in";
    });
    function s(p) {
      i.value && p.style.setProperty("--page-duration", `${t.duration}ms`);
    }
    function m() {
      l.value = "forward";
    }
    return (p, v) => {
      const y = fe("router-view");
      return $(), W(y, null, {
        default: X(({ Component: c, route: f }) => [
          G(U, {
            name: i.value ? u.value : "",
            mode: a.value,
            onBeforeEnter: s,
            onAfterLeave: m
          }, {
            default: X(() => [
              ($(), W(se(c), {
                key: f.path
              }))
            ]),
            _: 2
          }, 1032, ["name", "mode"])
        ]),
        _: 1
      });
    };
  }
}, Qe = {
  key: 0,
  class: "bottom-sheet__handle"
}, Ze = {
  __name: "BottomSheet",
  props: {
    modelValue: { type: Boolean, default: !1 },
    /** Snap breakpoints as fractions of viewport height, ascending order */
    breakpoints: { type: Array, default: () => [0.5] },
    /** Which breakpoint to open at (index into breakpoints array) */
    initialBreakpoint: { type: Number, default: 0 },
    /** Show drag handle */
    handle: { type: Boolean, default: !0 },
    /** Allow dismiss by swiping down */
    swipeToDismiss: { type: Boolean, default: !0 },
    /** Close on backdrop click */
    backdropClose: { type: Boolean, default: !0 },
    /** Border radius */
    rounded: { type: String, default: "20px" },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "closed", "snap"],
  setup(e, { emit: t }) {
    const n = e, i = t, { reducedMotion: r } = N(), l = T(() => n.motion && !r.value), u = k(null), a = k(0), s = k(!1);
    let m = 0, p = 0;
    const v = T(
      () => n.breakpoints.map((g) => Math.round(window.innerHeight * g))
    );
    q(() => n.modelValue, (g) => {
      g && me(() => {
        a.value = v.value[n.initialBreakpoint] || v.value[0];
      });
    });
    const y = T(() => ({
      height: `${a.value}px`,
      borderRadius: `${n.rounded} ${n.rounded} 0 0`,
      transition: s.value ? "none" : "height 300ms cubic-bezier(0.05, 0.7, 0.1, 1)"
    })), c = T(() => `${a.value - (n.handle ? 32 : 0)}px`);
    function f() {
      n.backdropClose && x();
    }
    function h(g) {
      const d = u.value;
      if (!d) return;
      const L = d.getBoundingClientRect();
      g.clientY - L.top > 40 && n.handle || (g.preventDefault(), m = g.clientY, p = a.value, s.value = !0, document.addEventListener("pointermove", w), document.addEventListener("pointerup", o));
    }
    function w(g) {
      if (!s.value) return;
      const d = m - g.clientY, L = Math.max(0, Math.min(window.innerHeight, p + d));
      a.value = L;
    }
    function o() {
      if (s.value) {
        if (s.value = !1, document.removeEventListener("pointermove", w), document.removeEventListener("pointerup", o), n.swipeToDismiss && a.value < v.value[0] * 0.4) {
          x();
          return;
        }
        b();
      }
    }
    function b() {
      const g = v.value;
      let d = g[0], L = Math.abs(a.value - d), A = 0;
      for (let M = 1; M < g.length; M++) {
        const S = Math.abs(a.value - g[M]);
        S < L && (d = g[M], L = S, A = M);
      }
      a.value = d, i("snap", A);
    }
    function x() {
      a.value = 0, setTimeout(() => i("update:modelValue", !1), l.value ? 300 : 0);
    }
    return (g, d) => ($(), W(ee, { to: "body" }, [
      G(U, {
        name: l.value ? "sheet-backdrop" : ""
      }, {
        default: X(() => [
          e.modelValue ? ($(), E("div", {
            key: 0,
            class: "sheet-backdrop",
            onClick: ie(f, ["self"])
          })) : z("", !0)
        ]),
        _: 1
      }, 8, ["name"]),
      G(U, {
        name: l.value ? "sheet" : "",
        onAfterLeave: d[0] || (d[0] = (L) => g.$emit("closed"))
      }, {
        default: X(() => [
          e.modelValue ? ($(), E("div", {
            key: 0,
            ref_key: "sheetRef",
            ref: u,
            class: "bottom-sheet",
            style: F(y.value),
            onPointerdown: h
          }, [
            e.handle ? ($(), E("div", Qe)) : z("", !0),
            I("div", {
              class: "bottom-sheet__content",
              style: F({ maxHeight: c.value })
            }, [
              B(g.$slots, "default", {}, void 0, !0)
            ], 4)
          ], 36)) : z("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}, jt = /* @__PURE__ */ R(Ze, [["__scopeId", "data-v-093565b1"]]), et = {
  __name: "ScaleModal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    /** Template ref or element that triggered the modal — scales from its position */
    origin: { type: Object, default: void 0 },
    /** Max width of modal */
    maxWidth: { type: String, default: "480px" },
    /** Full screen modal */
    fullscreen: { type: Boolean, default: !1 },
    /** Close on backdrop click */
    backdropClose: { type: Boolean, default: !0 },
    /** Border radius */
    rounded: { type: String, default: "20px" },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "closed"],
  setup(e, { emit: t }) {
    const n = e, i = t, { reducedMotion: r } = N(), l = T(() => n.motion && !r.value), u = k(null), a = k(null);
    function s() {
      const c = n.origin;
      return c ? c.__v_isRef ? c.value : c.$el ? c.$el : c instanceof HTMLElement ? c : null : null;
    }
    q(() => n.modelValue, (c) => {
      var f;
      if (c) {
        const h = s();
        a.value = ((f = h == null ? void 0 : h.getBoundingClientRect) == null ? void 0 : f.call(h)) ?? null;
      }
    });
    function m(c) {
      if (!l.value) return;
      const f = a.value;
      if (f) {
        const h = f.left + f.width / 2, w = f.top + f.height / 2;
        c.style.position = "fixed", c.style.left = `${h}px`, c.style.top = `${w}px`, c.style.transform = "translate(-50%, -50%) scale(0.3)", c.style.opacity = "0", c.style.transition = "none";
      } else
        c.style.transform = "translate(-50%, -50%) scale(0.8)", c.style.opacity = "0", c.style.transition = "none";
    }
    function p(c, f) {
      if (!l.value) {
        f();
        return;
      }
      requestAnimationFrame(() => {
        c.style.transition = "all 350ms cubic-bezier(0.05, 0.7, 0.1, 1)", c.style.left = "50%", c.style.top = "50%", c.style.transform = "translate(-50%, -50%) scale(1)", c.style.opacity = "1", setTimeout(f, 400);
      });
    }
    function v(c, f) {
      if (!l.value) {
        i("closed"), f();
        return;
      }
      const h = a.value;
      if (h) {
        const w = h.left + h.width / 2, o = h.top + h.height / 2;
        c.style.transition = "all 250ms cubic-bezier(0.3, 0, 0.8, 0.15)", c.style.left = `${w}px`, c.style.top = `${o}px`, c.style.transform = "translate(-50%, -50%) scale(0.3)", c.style.opacity = "0";
      } else
        c.style.transition = "all 200ms cubic-bezier(0.3, 0, 0.8, 0.15)", c.style.transform = "translate(-50%, -50%) scale(0.8)", c.style.opacity = "0";
      setTimeout(() => {
        i("closed"), f();
      }, 300);
    }
    function y() {
      n.backdropClose && i("update:modelValue", !1);
    }
    return (c, f) => ($(), W(ee, { to: "body" }, [
      G(U, {
        name: l.value ? "modal-backdrop" : ""
      }, {
        default: X(() => [
          e.modelValue ? ($(), E("div", {
            key: 0,
            class: "scale-modal-backdrop",
            onClick: ie(y, ["self"])
          })) : z("", !0)
        ]),
        _: 1
      }, 8, ["name"]),
      G(U, {
        name: (l.value, ""),
        css: !1,
        onBeforeEnter: m,
        onEnter: p,
        onLeave: v
      }, {
        default: X(() => [
          e.modelValue ? ($(), E("div", {
            key: 0,
            ref_key: "modalRef",
            ref: u,
            class: Y(["scale-modal", { "scale-modal--full": e.fullscreen }]),
            style: F({ maxWidth: e.fullscreen ? "none" : e.maxWidth, borderRadius: e.fullscreen ? "0" : e.rounded }),
            role: "dialog",
            "aria-modal": "true"
          }, [
            B(c.$slots, "default", {}, void 0, !0)
          ], 6)) : z("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}, qt = /* @__PURE__ */ R(et, [["__scopeId", "data-v-7ddceaa8"]]), Wt = {
  __name: "TabTransition",
  props: {
    /** Current tab index — direction is derived from changes to this value */
    index: { type: Number, required: !0 },
    /** Animation duration in ms */
    duration: { type: Number, default: 250 },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { reducedMotion: n } = N(), i = T(() => t.motion && !n.value), r = k("right");
    q(() => t.index, (u, a) => {
      a !== void 0 && (r.value = u > a ? "right" : "left");
    });
    const l = T(
      () => r.value === "right" ? "tab-slide-right" : "tab-slide-left"
    );
    return (u, a) => ($(), W(U, {
      name: i.value ? l.value : "",
      mode: "out-in"
    }, {
      default: X(() => [
        B(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["name"]));
  }
}, tt = ["onTouchstartPassive", "onTouchmovePassive", "onTouchend", "onMousedown"], nt = {
  __name: "SwipeCards",
  props: {
    /** Array of card data items */
    items: { type: Array, required: !0 },
    /** Key field name for v-for */
    keyField: { type: String, default: "id" },
    /** Number of cards visible in the stack */
    stackSize: { type: Number, default: 3 },
    /** px to drag before triggering swipe */
    swipeThreshold: { type: Number, default: 100 },
    /** px/ms velocity to trigger swipe */
    velocityThreshold: { type: Number, default: 0.5 },
    /** Max rotation in degrees at full swipe */
    maxRotation: { type: Number, default: 15 },
    /** Show accept/reject overlays */
    showOverlays: { type: Boolean, default: !0 },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["swipe-left", "swipe-right", "empty"],
  setup(e, { emit: t }) {
    const n = e, i = t, { reducedMotion: r } = N(), l = k(null), u = k(0), a = k(0), s = k(!1);
    let m = 0, p = 0, v = 0;
    const y = k(0), c = T(
      () => n.items.slice(y.value, y.value + n.stackSize)
    ), f = T(
      () => u.value / window.innerWidth * n.maxRotation
    ), h = T(
      () => Math.min(Math.max(u.value / n.swipeThreshold, 0), 1)
    ), w = T(
      () => Math.min(Math.max(-u.value / n.swipeThreshold, 0), 1)
    );
    function o(_) {
      if (_ === 0)
        return {
          transform: `translate(${u.value}px, ${a.value}px) rotate(${f.value}deg)`,
          transition: s.value ? "none" : "transform 400ms cubic-bezier(0.05, 0.7, 0.1, 1)",
          zIndex: 10,
          cursor: "grab"
        };
      const C = 1 - _ * 0.04, H = _ * 8;
      return {
        transform: `scale(${C}) translateY(${H}px)`,
        transition: "transform 400ms cubic-bezier(0.05, 0.7, 0.1, 1)",
        zIndex: 10 - _,
        pointerEvents: "none"
      };
    }
    function b(_) {
      L(_.touches[0].clientX, _.touches[0].clientY);
    }
    function x(_) {
      A(_.touches[0].clientX, _.touches[0].clientY);
    }
    function g() {
      M();
    }
    function d(_) {
      L(_.clientX, _.clientY);
      const C = (D) => A(D.clientX, D.clientY), H = () => {
        M(), document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", H);
      };
      document.addEventListener("mousemove", C), document.addEventListener("mouseup", H);
    }
    function L(_, C) {
      m = _, p = C, v = Date.now(), s.value = !0;
    }
    function A(_, C) {
      s.value && (u.value = _ - m, a.value = (C - p) * 0.3);
    }
    function M() {
      s.value = !1;
      const _ = Date.now() - v, C = Math.abs(u.value) / _;
      if (Math.abs(u.value) >= n.swipeThreshold || C >= n.velocityThreshold) {
        const D = u.value > 0 ? "right" : "left";
        S(D);
      } else
        u.value = 0, a.value = 0;
    }
    function S(_) {
      const C = window.innerWidth * 1.5 * (_ === "right" ? 1 : -1);
      r.value ? P(_) : (u.value = C, a.value = a.value * 2, setTimeout(() => {
        P(_);
      }, 400));
    }
    function P(_) {
      const C = c.value[0];
      i(_ === "right" ? "swipe-right" : "swipe-left", C), y.value++, u.value = 0, a.value = 0, y.value >= n.items.length && i("empty");
    }
    return (_, C) => ($(), E("div", {
      class: "swipe-cards",
      ref_key: "containerRef",
      ref: l
    }, [
      ($(!0), E(oe, null, ae(c.value, (H, D) => ($(), E("div", {
        key: H[e.keyField],
        class: Y(["swipe-cards__card", { "swipe-cards__card--active": D === 0 }]),
        style: F(o(D)),
        onTouchstartPassive: (K) => D === 0 && b(K),
        onTouchmovePassive: (K) => D === 0 && x(K),
        onTouchend: (K) => D === 0 && g(),
        onMousedown: (K) => D === 0 && d(K)
      }, [
        D === 0 && e.showOverlays ? ($(), E("div", {
          key: 0,
          class: "swipe-cards__overlay swipe-cards__overlay--right",
          style: F({ opacity: h.value })
        }, [
          B(_.$slots, "overlay-right", {}, () => [
            C[0] || (C[0] = I("span", { class: "swipe-cards__overlay-icon" }, "✓", -1))
          ], !0)
        ], 4)) : z("", !0),
        D === 0 && e.showOverlays ? ($(), E("div", {
          key: 1,
          class: "swipe-cards__overlay swipe-cards__overlay--left",
          style: F({ opacity: w.value })
        }, [
          B(_.$slots, "overlay-left", {}, () => [
            C[1] || (C[1] = I("span", { class: "swipe-cards__overlay-icon" }, "✗", -1))
          ], !0)
        ], 4)) : z("", !0),
        B(_.$slots, "default", {
          item: H,
          index: D,
          active: D === 0
        }, void 0, !0)
      ], 46, tt))), 128))
    ], 512));
  }
}, Vt = /* @__PURE__ */ R(nt, [["__scopeId", "data-v-d0af221f"]]), ot = {
  __name: "SwipeReveal",
  props: {
    /** Width of action buttons in px */
    actionWidth: { type: Number, default: 80 },
    /** Number of left-side actions */
    leftActions: { type: Number, default: 0 },
    /** Number of right-side actions */
    rightActions: { type: Number, default: 1 },
    /** Auto-snap threshold as fraction of action zone width */
    threshold: { type: Number, default: 0.4 },
    /** Disable swipe */
    disabled: { type: Boolean, default: !1 },
    motion: { type: Boolean, default: !0 }
  },
  emits: ["open", "close"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, { reducedMotion: l } = N(), u = k(null), a = k(0), s = k(!1), m = k("closed");
    let p = 0, v = 0, y = 0;
    const c = T(() => i.leftActions * i.actionWidth), f = T(() => i.rightActions * i.actionWidth), h = T(() => i.motion && !l.value), w = T(() => ({
      transform: `translateX(${a.value}px)`,
      transition: s.value ? "none" : h.value ? "transform 300ms cubic-bezier(0.05, 0.7, 0.1, 1)" : "none"
    })), o = T(() => ({
      width: `${c.value}px`,
      opacity: a.value > 0 ? Math.min(a.value / c.value, 1) : 0
    })), b = T(() => ({
      width: `${f.value}px`,
      opacity: a.value < 0 ? Math.min(-a.value / f.value, 1) : 0
    }));
    function x(M) {
      i.disabled || (M.preventDefault(), p = M.clientX, v = a.value, y = Date.now(), s.value = !0, document.addEventListener("pointermove", g), document.addEventListener("pointerup", d));
    }
    function g(M) {
      if (!s.value) return;
      let S = M.clientX - p + v;
      const P = c.value, _ = -f.value;
      if (S > P) {
        const C = S - P;
        S = P + C * 0.2;
      } else if (S < _) {
        const C = _ - S;
        S = _ - C * 0.2;
      }
      S > 0 && i.leftActions === 0 && (S = 0), S < 0 && i.rightActions === 0 && (S = 0), a.value = S;
    }
    function d(M) {
      s.value = !1, document.removeEventListener("pointermove", g), document.removeEventListener("pointerup", d);
      const S = (M.clientX - p) / (Date.now() - y);
      a.value > 0 ? a.value > c.value * i.threshold || S > 0.3 ? L(c.value, "left") : L(0, "closed") : a.value < 0 && (-a.value > f.value * i.threshold || S < -0.3) ? L(-f.value, "right") : L(0, "closed");
    }
    function L(M, S) {
      a.value = M;
      const P = m.value;
      m.value = S, S !== "closed" && P === "closed" ? r("open", S) : S === "closed" && P !== "closed" && r("close");
    }
    function A() {
      L(0, "closed");
    }
    return t({ close: A }), (M, S) => ($(), E("div", {
      class: "swipe-reveal",
      ref_key: "containerRef",
      ref: u
    }, [
      M.$slots.left ? ($(), E("div", {
        key: 0,
        class: "swipe-reveal__actions swipe-reveal__actions--left",
        style: F(o.value)
      }, [
        B(M.$slots, "left", {}, void 0, !0)
      ], 4)) : z("", !0),
      M.$slots.right ? ($(), E("div", {
        key: 1,
        class: "swipe-reveal__actions swipe-reveal__actions--right",
        style: F(b.value)
      }, [
        B(M.$slots, "right", {}, void 0, !0)
      ], 4)) : z("", !0),
      I("div", {
        class: "swipe-reveal__content",
        style: F(w.value),
        onPointerdown: x
      }, [
        B(M.$slots, "default", {}, void 0, !0)
      ], 36)
    ], 512));
  }
}, Ht = /* @__PURE__ */ R(ot, [["__scopeId", "data-v-f28d819c"]]), at = ["aria-valuenow"], rt = {
  key: 0,
  class: "progress-bar__label"
}, st = {
  __name: "ProgressBar",
  props: {
    /** Progress value 0-100 */
    value: { type: Number, default: 0 },
    /** Show indeterminate animation (ignores value) */
    indeterminate: { type: Boolean, default: !1 },
    /** Show percentage label */
    showLabel: { type: Boolean, default: !1 },
    /** Custom format function for label */
    format: { type: Function, default: null },
    /** Bar height */
    height: { type: [String, Number], default: 6 },
    /** Fill color */
    color: { type: String, default: "var(--accent, #6366f1)" },
    /** Track color */
    trackColor: { type: String, default: "var(--accent-light, rgba(99, 102, 241, 0.1))" },
    /** Border radius */
    rounded: { type: Boolean, default: !0 },
    /** Spring preset for value animation */
    spring: { type: [String, Object], default: "snappy" },
    motion: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = re(t, "value"), { current: i } = ue(n, t.motion ? t.spring : "stiff"), r = T(() => Math.round(Math.min(100, Math.max(0, i.value)))), l = T(() => t.format ? t.format(r.value) : `${r.value}%`), u = T(() => ({
      height: typeof t.height == "number" ? `${t.height}px` : t.height,
      background: t.trackColor,
      borderRadius: t.rounded ? "9999px" : "0"
    })), a = T(() => ({
      width: t.indeterminate ? "40%" : `${r.value}%`,
      background: t.color,
      borderRadius: t.rounded ? "9999px" : "0"
    }));
    return (s, m) => ($(), E("div", {
      class: Y(["progress-bar", { "progress-bar--indeterminate": e.indeterminate }]),
      role: "progressbar",
      "aria-valuenow": e.indeterminate ? void 0 : r.value,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, [
      I("div", {
        class: "progress-bar__track",
        style: F(u.value)
      }, [
        I("div", {
          class: "progress-bar__fill",
          style: F(a.value)
        }, null, 4)
      ], 4),
      e.showLabel && !e.indeterminate ? ($(), E("div", rt, [
        B(s.$slots, "default", {
          value: r.value,
          formatted: l.value
        }, () => [
          Q(O(l.value), 1)
        ], !0)
      ])) : z("", !0)
    ], 10, at));
  }
}, Ut = /* @__PURE__ */ R(st, [["__scopeId", "data-v-84c23ce6"]]);
function it(e) {
  const n = getComputedStyle(e).backgroundColor.match(/\d+/g);
  if (!n) return "rgba(0, 0, 0, 0.12)";
  const [i, r, l] = n.map(Number);
  return (0.299 * i + 0.587 * r + 0.114 * l) / 255 > 0.5 ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.2)";
}
function lt(e, t, n) {
  const { color: i, duration: r = 400, center: l = !1 } = n, u = e.getBoundingClientRect(), a = Math.max(u.width, u.height) * 2, s = l ? u.width / 2 : t.clientX - u.left, m = l ? u.height / 2 : t.clientY - u.top, p = document.createElement("span");
  Object.assign(p.style, {
    position: "absolute",
    width: `${a}px`,
    height: `${a}px`,
    left: `${s - a / 2}px`,
    top: `${m - a / 2}px`,
    borderRadius: "50%",
    backgroundColor: i || it(e),
    transform: "scale(0)",
    opacity: "1",
    pointerEvents: "none",
    transition: `transform ${r}ms cubic-bezier(0.05, 0.7, 0.1, 1.0), opacity ${r * 0.6}ms ease ${r * 0.4}ms`
  }), (!e.style.position || e.style.position === "static") && (e.style.position = "relative"), e.style.overflow = "hidden", e.appendChild(p), requestAnimationFrame(() => {
    p.style.transform = "scale(1)", p.style.opacity = "0";
  }), setTimeout(() => p.remove(), r);
}
const ut = {
  mounted(e, t) {
    const n = typeof t.value == "object" ? t.value : {};
    n.disabled || (e._rippleHandler = (i) => lt(e, i, n), e.addEventListener("pointerdown", e._rippleHandler));
  },
  updated(e, t) {
    (typeof t.value == "object" ? t.value : {}).disabled && e.removeEventListener("pointerdown", e._rippleHandler);
  },
  unmounted(e) {
    e._rippleHandler && e.removeEventListener("pointerdown", e._rippleHandler);
  }
}, ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vRipple: ut
}, Symbol.toStringTag, { value: "Module" })), dt = {
  scale: 0.95,
  duration: 100,
  releaseDuration: 300
}, ft = {
  mounted(e, t) {
    const n = { ...dt, ...typeof t.value == "object" ? t.value : {} };
    if (n.disabled) return;
    e.style.transformOrigin = "center", e.style.userSelect = "none", e.style.webkitUserSelect = "none";
    const i = () => {
      e.style.transition = `transform ${n.duration}ms cubic-bezier(0.2, 0, 0, 1)`, e.style.transform = `scale(${n.scale})`;
    }, r = () => {
      e.style.transition = `transform ${n.releaseDuration}ms var(--ease-spring, cubic-bezier(0.25, 0.1, 0.25, 1))`, e.style.transform = "scale(1)";
    };
    e.addEventListener("pointerdown", i), e.addEventListener("pointerup", r), e.addEventListener("pointerleave", r), e.addEventListener("pointercancel", r), e._pressCleanup = () => {
      e.removeEventListener("pointerdown", i), e.removeEventListener("pointerup", r), e.removeEventListener("pointerleave", r), e.removeEventListener("pointercancel", r);
    };
  },
  unmounted(e) {
    var t;
    (t = e._pressCleanup) == null || t.call(e);
  }
}, mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vPress: ft
}, Symbol.toStringTag, { value: "Module" })), pt = {
  mounted(e, t) {
    const n = typeof t.value == "object" ? t.value : { speed: t.value ?? 0.5 };
    if (n.disabled) return;
    let i = !1;
    function r() {
      i || (i = !0, requestAnimationFrame(() => {
        const l = e.getBoundingClientRect(), u = window.innerHeight / 2, m = (l.top + l.height / 2 - u) * n.speed * -1;
        e.style.transform = `translate3d(0, ${m}px, 0)`, i = !1;
      }));
    }
    window.addEventListener("scroll", r, { passive: !0 }), r(), e._parallaxCleanup = () => window.removeEventListener("scroll", r);
  },
  unmounted(e) {
    var t;
    (t = e._parallaxCleanup) == null || t.call(e);
  }
}, vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vParallax: pt
}, Symbol.toStringTag, { value: "Module" })), Z = {
  "fade-up": { from: { opacity: "0", transform: "translateY(30px)" }, to: { opacity: "1", transform: "translateY(0)" } },
  "fade-down": { from: { opacity: "0", transform: "translateY(-30px)" }, to: { opacity: "1", transform: "translateY(0)" } },
  "fade-left": { from: { opacity: "0", transform: "translateX(30px)" }, to: { opacity: "1", transform: "translateX(0)" } },
  "fade-right": { from: { opacity: "0", transform: "translateX(-30px)" }, to: { opacity: "1", transform: "translateX(0)" } },
  "zoom-in": { from: { opacity: "0", transform: "scale(0.9)" }, to: { opacity: "1", transform: "scale(1)" } },
  "zoom-out": { from: { opacity: "0", transform: "scale(1.1)" }, to: { opacity: "1", transform: "scale(1)" } }
}, yt = {
  mounted(e, t) {
    const n = typeof t.value == "object" ? t.value : {};
    if (n.disabled) return;
    const {
      animation: i = "fade-up",
      threshold: r = 0.15,
      duration: l = 500,
      delay: u = 0,
      once: a = !0
    } = n;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      Object.assign(e.style, Z[i].to);
      return;
    }
    Object.assign(e.style, Z[i].from);
    const m = new IntersectionObserver(
      ([p]) => {
        p.isIntersecting ? (e.style.transition = `all ${l}ms cubic-bezier(0.05, 0.7, 0.1, 1.0) ${u}ms`, Object.assign(e.style, Z[i].to), a && m.disconnect()) : a || (e.style.transition = "none", Object.assign(e.style, Z[i].from));
      },
      { threshold: r }
    );
    m.observe(e), e._appearCleanup = () => m.disconnect();
  },
  unmounted(e) {
    var t;
    (t = e._appearCleanup) == null || t.call(e);
  }
}, ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vAppear: yt
}, Symbol.toStringTag, { value: "Module" })), gt = {
  duration: 500,
  haptic: !1
}, Gt = {
  mounted(e, t) {
    var c;
    const n = typeof t.value == "function" ? t.value : (c = t.value) == null ? void 0 : c.handler, i = {
      ...gt,
      ...typeof t.value == "object" ? t.value : {}
    };
    if (!n) return;
    let r = null, l = !1;
    const u = 10;
    let a = 0, s = 0;
    function m(f) {
      var h, w, o, b;
      l = !1, a = f.clientX ?? ((w = (h = f.touches) == null ? void 0 : h[0]) == null ? void 0 : w.clientX) ?? 0, s = f.clientY ?? ((b = (o = f.touches) == null ? void 0 : o[0]) == null ? void 0 : b.clientY) ?? 0, r = setTimeout(() => {
        l = !0, n(f), i.haptic && navigator.vibrate && navigator.vibrate(50);
      }, i.duration);
    }
    function p(f) {
      var x, g, d, L;
      if (!r) return;
      const h = f.clientX ?? ((g = (x = f.touches) == null ? void 0 : x[0]) == null ? void 0 : g.clientX) ?? 0, w = f.clientY ?? ((L = (d = f.touches) == null ? void 0 : d[0]) == null ? void 0 : L.clientY) ?? 0, o = Math.abs(h - a), b = Math.abs(w - s);
      (o > u || b > u) && (clearTimeout(r), r = null);
    }
    function v(f) {
      clearTimeout(r), r = null, l && (f.preventDefault(), f.stopPropagation());
    }
    function y() {
      clearTimeout(r), r = null;
    }
    e.addEventListener("pointerdown", m), e.addEventListener("pointermove", p), e.addEventListener("pointerup", v), e.addEventListener("pointercancel", y), e.addEventListener("contextmenu", (f) => {
      l && f.preventDefault();
    }), e._longpressCleanup = () => {
      clearTimeout(r), e.removeEventListener("pointerdown", m), e.removeEventListener("pointermove", p), e.removeEventListener("pointerup", v), e.removeEventListener("pointercancel", y);
    };
  },
  unmounted(e) {
    var t;
    (t = e._longpressCleanup) == null || t.call(e);
  }
};
function Kt(e) {
  const t = T({
    get: () => e.global.current.value.dark,
    set: (l) => {
      e.global.name.value = l ? "dark" : "light";
    }
  }), n = T(() => e.global.name.value);
  le(() => {
    document.documentElement.classList.toggle("dark", t.value);
  });
  function i(l) {
    if (l === "system") {
      const u = window.matchMedia("(prefers-color-scheme: dark)").matches;
      e.global.name.value = u ? "dark" : "light";
    } else
      e.global.name.value = l;
  }
  async function r(l) {
    const u = !t.value;
    if (l && document.startViewTransition) {
      const a = l.clientX, s = l.clientY, m = Math.hypot(
        Math.max(a, window.innerWidth - a),
        Math.max(s, window.innerHeight - s)
      );
      await document.startViewTransition(() => {
        i(u ? "dark" : "light");
      }).ready, document.documentElement.animate(
        {
          clipPath: [
            `circle(0px at ${a}px ${s}px)`,
            `circle(${m}px at ${a}px ${s}px)`
          ]
        },
        {
          duration: 500,
          easing: "cubic-bezier(0.4, 0, 0.2, 1)",
          pseudoElement: "::view-transition-new(root)"
        }
      );
    } else
      i(u ? "dark" : "light");
  }
  return { isDark: t, preference: n, toggle: r, set: i };
}
function Jt(e) {
  le(() => {
    const t = e.global.current.value.colors, n = document.documentElement.style;
    t.primary && (n.setProperty("--accent", t.primary), n.setProperty("--accent-light", bt(t.primary, 0.1)), n.setProperty("--empty-button-bg", t.primary)), t.error && (n.setProperty("--error-icon-color", t.error), n.setProperty("--error-retry-border", t.error), n.setProperty("--error-retry-color", t.error)), t.surface && n.setProperty("--bg-surface", t.surface), t.background && n.setProperty("--bg", t.background);
    const i = e.global.current.value.dark;
    i ? (n.setProperty("--skeleton-base", "#2a2a2a"), n.setProperty("--skeleton-highlight", "#3a3a3a"), n.setProperty("--text-primary", "#f3f4f6"), n.setProperty("--text-secondary", "#9ca3af")) : (n.setProperty("--skeleton-base", "#e0e0e0"), n.setProperty("--skeleton-highlight", "#f0f0f0"), n.setProperty("--text-primary", "#1f2937"), n.setProperty("--text-secondary", "#6b7280")), i ? (n.setProperty("--glass-shadow", "0 8px 32px rgba(0, 0, 0, 0.3)"), n.setProperty("--glass-border-color", "rgba(255, 255, 255, 0.08)"), n.setProperty("--glass-inset-highlight", "rgba(255, 255, 255, 0.06)")) : (n.setProperty("--glass-shadow", "0 8px 32px rgba(0, 0, 0, 0.08)"), n.setProperty("--glass-border-color", "rgba(255, 255, 255, 0.18)"), n.setProperty("--glass-inset-highlight", "rgba(255, 255, 255, 0.2)"));
  });
}
const Qt = {
  install(e) {
    Promise.resolve().then(() => ct).then(({ vRipple: t }) => e.directive("ripple", t)), Promise.resolve().then(() => mt).then(({ vPress: t }) => e.directive("press", t)), Promise.resolve().then(() => vt).then(({ vParallax: t }) => e.directive("parallax", t)), Promise.resolve().then(() => ht).then(({ vAppear: t }) => e.directive("appear", t)), Promise.resolve({           }), Promise.resolve({                   });
  }
};
function bt(e, t) {
  const n = e.replace("#", ""), i = parseInt(n.slice(0, 2), 16), r = parseInt(n.slice(2, 4), 16), l = parseInt(n.slice(4, 6), 16);
  return `rgba(${i}, ${r}, ${l}, ${t})`;
}
export {
  Ot as AchievementToast,
  zt as AnimatedCounter,
  jt as BottomSheet,
  Le as Confetti,
  Dt as EmptyState,
  Rt as ErrorState,
  Yt as Fireworks,
  Ft as GlassCard,
  It as MorphButton,
  Xt as PageTransition,
  Ut as ProgressBar,
  At as ProgressiveImage,
  J as SCROLL_ANIMATIONS,
  ve as SPRING_PRESETS,
  qt as ScaleModal,
  Bt as Skeleton,
  Nt as StaggeredList,
  Vt as SwipeCards,
  Ht as SwipeReveal,
  Wt as TabTransition,
  Qt as VueInstylePlugin,
  Et as useAdaptiveColor,
  _t as useDarkMode,
  Kt as useDarkModeVuetify,
  xt as useEasterEgg,
  Mt as useHapticFeedback,
  $t as useOptimisticUpdate,
  Tt as usePrefetch,
  Ct as usePullToRefresh,
  N as useReducedMotion,
  St as useScrollAnimation,
  Lt as useSharedTransition,
  ue as useSpring,
  Pt as useSwipeBack,
  Jt as useVuetifyTokens,
  yt as vAppear,
  Gt as vLongpress,
  pt as vParallax,
  ft as vPress,
  ut as vRipple
};
